<template>
  <section class="Whishlist" id="whishlist-page">
    <div class="page-banner orders-banner">
      <el-row>
        <el-col :lg="24">
          <div class="image">
            <img
              src="/img/page-banners/orders.jpg"
              alt="storeLocator-page-banner"
              class="img-fluid"
            />
            <div class="banner-cover">
              <div class="banner-cover-inner">
                <ul class="bredcums-list">
                  <li>
                    <router-link to="/">Home</router-link>
                  </li>

                  <li>
                    <router-link to="/">Wishlist</router-link>
                  </li>
                </ul>
                <h3 class="bredcums-title">Wishlist</h3>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <section class="section-pad">
      <el-row type="flex" justify="center">
        <el-col :lg="20">
          <div class="order-details-table">
            <el-table :data="orderDetails" height="550" style="width: 100%">
              <el-table-column prop="id" width="80"></el-table-column>
              <el-table-column label="Product">
                <template slot-scope="scope">
                  <div class="product-group">
                    <div class="product-image">
                      <img
                        :src="'/img/accessories/'+ scope.row.product.image "
                        :alt="scope.row.product.name"
                        class="img-fluid"
                      />
                    </div>
                    <div class="product-details">
                      <h3>{{scope.row.product.name}}</h3>
                      <p>{{scope.row.product.description}}</p>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="price" label="Price" width="180"></el-table-column>
              <el-table-column prop="quantity" label="Quantity" width="180"></el-table-column>
              <el-table-column prop="total" label="Total" width="180"></el-table-column>
            </el-table>
          </div>
        </el-col>
      </el-row>
    </section>
  </section>
</template>

<script>
import AdminDefault from "@/layouts/AdminDefault";

export default {
  created() {
    this.$emit("update:layout", AdminDefault);
  }
};
</script>


<style lang="scss">
</style>
